var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIssueWithInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Insurance_exp",
    clipPath: "url(#clip0_1232_24224)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "safe_alert_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.468 1.46374L13.1347 3.21374C13.3889 3.30903 13.6079 3.47964 13.7626 3.70278C13.9172 3.92591 14 4.19093 14 4.46241V8.03774C14 9.15202 13.6898 10.2443 13.104 11.1922C12.5182 12.1401 11.68 12.9061 10.6833 13.4044L8.44733 14.5217C8.30845 14.5912 8.15529 14.6274 8 14.6274C7.84471 14.6274 7.69155 14.5912 7.55267 14.5217L5.31667 13.4037C4.32003 12.9054 3.48185 12.1394 2.89605 11.1915C2.31025 10.2436 1.99998 9.15136 2 8.03707V4.46307C1.99983 4.19148 2.0826 3.92632 2.23725 3.70305C2.39189 3.47978 2.61102 3.30907 2.86533 3.21374L7.532 1.46374C7.83375 1.35063 8.16625 1.35063 8.468 1.46374ZM8 9.33374C7.82319 9.33374 7.65362 9.40398 7.5286 9.529C7.40357 9.65403 7.33333 9.8236 7.33333 10.0004C7.33333 10.1772 7.40357 10.3468 7.5286 10.4718C7.65362 10.5968 7.82319 10.6671 8 10.6671C8.17681 10.6671 8.34638 10.5968 8.4714 10.4718C8.59643 10.3468 8.66667 10.1772 8.66667 10.0004C8.66667 9.8236 8.59643 9.65403 8.4714 9.529C8.34638 9.40398 8.17681 9.33374 8 9.33374ZM8 4.66707C7.83671 4.66709 7.67911 4.72704 7.55709 4.83555C7.43506 4.94406 7.3571 5.09357 7.338 5.25574L7.33333 5.33374V8.00041C7.33352 8.17033 7.39859 8.33376 7.51523 8.45732C7.63188 8.58088 7.7913 8.65523 7.96093 8.66519C8.13056 8.67515 8.29759 8.61996 8.42789 8.5109C8.55819 8.40184 8.64193 8.24714 8.662 8.07841L8.66667 8.00041V5.33374C8.66667 5.15693 8.59643 4.98736 8.4714 4.86233C8.34638 4.73731 8.17681 4.66707 8 4.66707Z",
    fill: "#EDCA31"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_24224"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssueWithInsurance);
export default __webpack_public_path__ + "static/media/issue-with-insurance.0a0a1d798b130b5121ad3bd2940a494d.svg";
export { ForwardRef as ReactComponent };